export enum ImageOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square',
  Circle = 'circle',
  LandscapeOval = 'landscape-oval',
  PortraitOval = 'portrait-oval',
}
export enum ImageAspectRatio {
  FourByThree = '4:3',
  SixteenByNine = '16:9',
  OneByOne = '1:1',
}

export enum DynamicAspect {
  Auto = 'auto',
  Square = 'square',
}
